import * as React from "react";
import { cn } from "@/lib/utils";

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  error?: boolean;
};

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        "flex h-11 w-full rounded-[8px] border bg-white px-3 text-base",
        "placeholder:text-text-subtle",
        "focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-brand-500",
        "disabled:cursor-not-allowed disabled:opacity-50",
        error
          ? "border-[var(--color-error-600)]"
          : "border-border-strong",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";

export const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement> & { error?: boolean }
>(({ className, error, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      "flex min-h-[88px] w-full rounded-[8px] border bg-white px-3 py-2 text-base",
      "placeholder:text-text-subtle",
      "focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-brand-500",
      "disabled:cursor-not-allowed disabled:opacity-50",
      error
        ? "border-[var(--color-error-600)]"
        : "border-border-strong",
      className,
    )}
    {...props}
  />
));
Textarea.displayName = "Textarea";
